<div class="message-box">
    <p *ngIf="showMessage" @insertRemoveTrigger (click)="removeMessage()">{{ message }}</p>
</div>
